<template>
  <div class="look-detail">
    <div v-show="detailObj.type == 1" class="full-detail" style="position: relative">
      <div id="detailtext"></div>
    </div>

    <!-- 公众号 -->
    <div v-if="isIosText" class="official-account">
      <img src="../../assets/images/picweb.png" alt="" />
      <p>IOS不支持第三方链接自动跳转，请手动点击下方链接进行查看</p>
      <div class="article" @click="openText">
        {{ detailObj.siteName }}
      </div>
    </div>
  </div>
</template>
<script>
import { getUrlParam } from "@/utils/public.js";
import { readSave, encodeEncrypt, findId, weRadarCountVo } from "@/server/api.js";
import Pdfh5 from "pdfh5";
import { Toast } from "vant";
import "pdfh5/css/pdfh5.css";

// openFile?name=QFEDU_lH3ErvOmCjo9EoV+63lKbw==
// QFEDU_mFx4bxzSjKntG1k6FyljQQ2+1LdlvYN3ZB08b+uOWYcdv+GjvKmTiFjIix0hvP1q
let APPID = window.document.domain === "xyqw.xinyuanhulian.com" ? "ww29a0b9ab8da601a6" : "wx0de53b5d3a717289";
export default {
  data() {
    return {
      pdfh5url: null,
      pdfPages: [],
      pdfurl: "",
      // "https://storage.qfedu.com/qwdoc/1686300842304.知乎盐选 _ 什么是产品？什么是产品经理？——附腾讯产品经理能力模型.pdf",
      personObj: {
        userId: "",
        wechatId: "",
        fileId: "",
      },
      detailObj: {
        type: "",
      },
      APPID: APPID,
      siteUrl: "",
      pdfDoc: "",
      pdfScale: 1.0,
      starttime: "",
      timer: null,
      time: 0,
      isIosText: false,
      nameQuery: "",
    };
  },
  mounted() {
    if (this.$route.query.name) {
      //   this.encodeParame();
      this.nameQuery = this.$route.query.name;
      this.codeFile();
    }
  },
  methods: {
    codeFile() {
      const code = getUrlParam("code");
      const local = window.location.href;
      if (code == null || code === "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_base&state=" +
          encodeURIComponent(this.nameQuery) +
          "#wechat_redirect";
        // "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        // this.APPID +
        // "&redirect_uri=" +
        // encodeURIComponent(local) +
        // "&response_type=code&scope=snsapi_userinfo&forcePopup=true&state=" +
        // encodeURIComponent(this.nameQuery) +
        // "#wechat_redirect";
      } else {
        this.nameQuery = getUrlParam("state");
        this.encodeParame();
      }
    },
    phoneHandle() {
      this.time = 0;
      let obj = {
        key: decodeURIComponent(this.nameQuery),
        // this.$route.query.name
        weRadarReading: {
          externalUserid: this.personObj.wechatId,
          radarId: this.personObj.fileId,
          type: 2,
          userId: this.personObj.userId,
        },
      };
      this.timer = setInterval(() => {
        this.time += 3;
        obj.time = this.time;
        //
        weRadarCountVo(obj).then((res) => {});
      }, 3000);
    },
    // 获取url
    async encodeParame() {
      // this.$route.query.name
      let res = await encodeEncrypt({
        urlParmp: decodeURIComponent(this.nameQuery),
      });
      if (res.code !== "200") return Toast.fail(res.msg);
      this.personObj = res.data;
      let response = await findId(this.personObj.fileId);
      if (response.code !== "200") return Toast.fail(response.msg);
      this.detailObj = response.data;
      this.pdfurl = response.data.siteUrl;
      // 区分环境
      let lookdevelop = navigator.userAgent.toLowerCase();
      let isWechat = lookdevelop.match(/MicroMessenger/i) == "micromessenger";
      let isWxWork = lookdevelop.match(/WxWork/i) == "wxwork";

      // 预览pdf还是网站
      if (response.data.type == 2 && isWechat && !isWxWork) {
        this.statistics();
      } else {
        // 打开pdf
        await this.openPdf(isWechat, isWxWork);
      }
      // 网站跳转
      if (response.data.type == 2) {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        if (isAndroid) {
          window.open(this.pdfurl);
        } else {
          this.isIosText = true;
        }
      }
    },
    openText() {
      window.location.href = this.pdfurl;
    },
    openPdf(isWechat, isWxWork) {
      if (this.pdfh5url) {
        this.pdfh5url.destroy();
        this.pdfh5url = null;
      }
      this.pdfh5url = new Pdfh5("#detailtext", {
        URIenable: false,
        pdfurl: this.pdfurl,
        maxZoom: 3,
        lazy: true,
        scrollEnable: true,
        // clientheight: 0,
      });
      this.pdfh5url.scrollEnable = true;
      let that = this;
      this.pdfh5url.on("ready", function () {
        that.starttime = new Date();
        // that.statistics();
        if (isWechat && !isWxWork) {
          that.phoneHandle();
        }
      });
    },

    statistics() {
      console.log(10);
      let obj = {
        externalUserid: this.personObj.wechatId,
        radarId: this.personObj.fileId,
        type: 1,
        userId: this.personObj.userId,
      };
      readSave(obj).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
      });
    },
  },
  beforeDestroy() {
    this.pdfurl = "";
    clearInterval(this.timer);
  },
};
</script>
<style lang="less">
.look-detail {
  width: 100vw;
  height: 100vh;
}
#detailtext {
  width: 100% !important;
  height: 100% !important;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  -webkit-overflow: scroll;
}
.down-icon {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #7c6d6d;
  border: solid 1px #7c6d6d;
  border-radius: 50%;
  padding: 8px 8px;
  z-index: 99;
}
.full-detail {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
}
.site-detail {
  width: 100%;
  height: 100%;
}

.official-account {
  text-align: center;
  padding: 260px 90px 0;
  img {
    width: 220px;
  }
  p {
    font-size: 26px;
    padding: 90px 0 110px;
    color: #3d3d3d;
  }
  .article {
    color: #277fff;
    font-size: 30px;
    text-decoration: underline;
  }
}
</style>
